module.exports = {
  initialize : () => { console.log('initialize push manager')},
  addEventListener : responder => {
    console.log('push manager - add event listener', responder)
  },
  removeEventListener : responder => {
    console.log('push manager - remove event listener', responder)
  }
}
